<script setup lang="ts">
    import { useDeveloperSettings } from '@/stores/developerSettings';
    import { logLevels } from '@/util';
    import DevSettingCheckbox from '@/views/3d-planner/components/developerTools/DevSettingCheckbox.vue';

    const settings = useDeveloperSettings();

    function testError() {
        throw new Error('Test error');
    }
</script>

<template>
 <div class="d-flex flex-column expansion-panel">
        <v-btn
            color="planner-grey"
            class="my-2 button"
            @click="settings.showDeveloperTools = false"
        >
            Hide tools
        </v-btn>
        <v-select
            v-model="settings.validationLogLevel"
            label="Validation logging level"
            :items="logLevels.filter((level) => level !== 'warn')"
            color="primary"
            variant="underlined"
            class="my-2"
            hide-details
        />
        <dev-setting-checkbox v-model="settings.show3dFeatures" label="Show 3d features" />
        <v-btn color="error" class="my-2 button error-button" @click="testError">
            Test Error Handling
        </v-btn>
        <dev-setting-checkbox v-model="settings.animateCameras" label="Animate camera" />
        <dev-setting-checkbox v-model="settings.highlightOutlines" label="Highlight outlines" />
        <dev-setting-checkbox
            v-model="settings.suppressReloadErrors"
            label="Suppress reload errors"
        />
    </div>
</template>

<style scoped>
    .button {
        text-transform: inherit;
    }

    .error-button {
        text-transform: inherit;
    }

    .expansion-panel {
        min-width: 400px;
        background-color: rgb(var(--v-theme-surface-light));
        padding: 20px 20px 0 20px;
        border-radius: 12px 12px 0 0;
        position: relative;
        left: -10px;
        gap: 10px;
        display: flex;
        flex-direction: column;
    }
</style>
